//  ContentContainer.js
//
//  Updated 3/4.
//
//  Abstract: Dashboard content container.

//	React
import React, { useState } from 'react';
//	Material-ui styles
import {
	Card,
	Container,
	Typography,
	makeStyles,
	CircularProgress
} from '@material-ui/core';

//	CSS styles`
const useStyles = makeStyles((theme) => ({
	container: {
		marginTop: '10vh',
	}
}));

export default function ContentContainer(props) {
	
	const classes = useStyles();
	const { isLoading } = props;

	//	On component loading
	if (isLoading) {
		return (
			<div className={classes.root}>
				{isLoading && <CircularProgress size={40} color="tertiary" className={classes.uiProgess} />}
			</div>
		);
	} else {
		return (
			<>
				<Container className={classes.container}>
					<Card variant="outlined">
						{props.children}
					</Card>
				</Container>
			</>
		);
	}
}
